import {
  useEmbedConfigureStore,
  type IComponentSettings
} from '@/stores/embeds/embedConfigure.store'
import { useIdeStore, type ILibsLanguage } from '@/stores/embeds/ide.store'
import { JDOODLEBLOCKSNAMES } from '@/utils/embeds/editorMeta'
import { cloneDeep } from 'lodash-es'
/**
 * On setting change
 */
const onSettingChange = () => {
  const settongs = useEmbedConfigureStore().getComponentSettings?.find(
    (componentSetting: IComponentSettings) =>
      componentSetting.componentName === JDOODLEBLOCKSNAMES.LIBSCOMP
  )?.configStyle
  const canEdit = settongs?.find((setting) => setting.id === 'canEdit')?.value || 'true'
  useIdeStore().setLibsCanEdit(canEdit === 'true' || false)
}
/**
 * Get default libs
 */
const getDefaultLibs = () => {
  const libsLanguage: ILibsLanguage[] =
    cloneDeep(useEmbedConfigureStore()).getEmbedConfig?.languages.map((language) => {
      return {
        [language.language]: language.libs
      }
    }) || []
  useIdeStore().setLibsLanguage(libsLanguage)
}
/**
 * Init language list
 */
const initLibs = () => {
  getDefaultLibs()
}
/**
 * Eject stdin argus
 */
const destroyLibs = () => {
  getDefaultLibs()
}
export default {
  initLibs,
  onSettingChange,
  destroyLibs
}
